<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title primary-title>
            <h3>{{ strings.forgotPassword }}</h3>
          </v-card-title>
          <v-form
            v-if="!loading"
            ref="form"
            v-model="valid"
            lazy-validation
            class="forgot"
          >
            <v-text-field
              v-model="username"
              label="Username"
              required
              autocomplete="Username"
              :rules="usernameRules"
            />
            <v-text-field
              v-model="email"
              :rules="emailRules"
              type="text"
              name="input-10-1"
              label="Email"
              required
              autocomplete="Email"
            />
            <v-btn
              color="primary"
              @click="onSendEmail"
            >
              {{ strings.reset }}
            </v-btn>
          </v-form>
          <v-layout v-if="loading">
            <v-flex>
              <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
              />
            </v-flex>
          </v-layout>
          <v-layout
            v-if="
              editPasswordResponse != null && editPasswordResponse != undefined
            "
          >
            <v-flex
              grow
              @click="onEditPasswordResponseClick"
            >
              <v-alert
                :value="editPasswordResponse"
                type="success"
              >
                <v-layout
                  align-space-around
                  justify-space-around
                  row
                  fill-height
                >
                  <v-flex grow>
                    <h4 class="success-message">
                      {{ successMessage }}
                    </h4>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      small
                      fab
                      dark
                      color="rgba(0,0,0,.3)"
                      class="text-xs-right"
                      @click="onSuccessMessageOK"
                    >
                      {{ strings.ok }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-alert>
              <v-alert
                :value="!editPasswordResponse"
                type="error"
              >
                {{ failMessage }}
              </v-alert>
            </v-flex>
          </v-layout>
          <v-layout v-if="error">
            <v-flex>
              <v-alert
                :value="true"
                color="error"
                icon="mdi-alert"
                @click="onErrorMessageClick"
              >
                {{ errorMessage }}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    username: "",
    usernameRules: [v => !!v || "Username is required"],
    successMessage: "Email sent succesfully",
    failMessage:
      "Could not send the new password email. Please check the credentials given",
    errorMessage: "Oops... somthing went wrong please try again later"
  }),
  computed: {
    ...mapGetters("login", {
      loading: "loading",
      error: "error",
      editPasswordResponse: "editPasswordResponse"
    }),
    ...mapGetters("page", ["strings"])
  },
  methods: {
    onSendEmail() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("login/forgotPassword", {
          username: this.username,
          email: this.email
        });
      }
    },
    onErrorMessageClick() {
      this.$store.commit("login/clearError");
    },
    onEditPasswordResponseClick() {
      this.$store.commit("login/clearEditPasswordResponse");
    },
    onSuccessMessageOK() {
      this.$router.push("/login");
    }
  }
};
</script>

<style scoped>
.v-btn {
  color: var(--v-text-base) !important;
}
.v-form.forgot {
  padding: 1em 2em 1em 2em;
}
h4.success-message {
  padding-top: 1rem;
}
</style>
